import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { CreateAttendanceEditTimesheetRequestMutationVariables } from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onCloseModal: () => void
}

const ModalFooter = ({ onCloseModal }: Props) => {
  const form = useFormContext<CreateAttendanceEditTimesheetRequestMutationVariables>()

  return (
    <>
      <Button onClick={onCloseModal} type="secondary" disabled={form.isSubmitting}>
        {i18n.t('common.cancel')}
      </Button>
      <Button
        onClick={() => form.handleSubmit()}
        disabled={form.isSubmitting || !isEmpty(form.errors)}
      >
        {i18n.t('clock_in.edit_timesheet_requests.modal.request_button')}
      </Button>
    </>
  )
}

export default ModalFooter
